import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { ArrowLeft, Package, ReceiptText } from 'lucide-react';
import { base44 } from '@/api/base44Client';
import MarketingProductCard from '@/Components/client-po/MarketingProductCard';

export default function PurchasingInvoiceDetail() {
  const navigate = useNavigate();
  const location = useLocation();
  const { poId } = useParams();
  const po = location.state?.po;

  const { data: botolList = [] } = useQuery({ queryKey: ['botol'], queryFn: () => base44.entities.Botol.list() });
  const { data: tutupList = [] } = useQuery({ queryKey: ['tutup'], queryFn: () => base44.entities.Tutup.list() });
  const { data: sprayList = [] } = useQuery({ queryKey: ['spray'], queryFn: () => base44.entities.Spray.list() });
  const { data: bahanList = [] } = useQuery({ queryKey: ['bahan_cair'], queryFn: () => base44.entities.BahanCair.list() });
  const { data: fullsetList = [] } = useQuery({ queryKey: ['fullset'], queryFn: () => base44.entities.Fullset.list() });

  if (!po) {
    return (
      <div className="p-8 text-center">
        <h2 className="text-xl font-bold mb-4">Invoice tidak ditemukan atau data kedaluwarsa</h2>
        <button 
          onClick={() => navigate(-1)}
          className="px-4 py-2 bg-[#8C6208] text-white rounded-lg hover:bg-[#6A4A06]"
        >
          Kembali
        </button>
      </div>
    );
  }

  return (
    <div className="p-6 md:p-8 space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500 max-w-5xl mx-auto text-[#302621]">
      <div className="flex items-center gap-4">
        <button 
          onClick={() => navigate(-1)}
          className="p-2 hover:bg-slate-100 rounded-lg transition-colors text-slate-500"
        >
          <ArrowLeft className="w-5 h-5" />
        </button>
        <div>
          <h1 className="text-2xl md:text-3xl font-black text-slate-800 tracking-tight flex items-center gap-3">
            <ReceiptText className="w-8 h-8 text-[#8C6208]" /> 
            Detail Invoice #{po.id || poId}
          </h1>
          <p className="text-sm text-slate-500 mt-1">
            Klien: {po.customerName || po.brand_name || 'Klien'}
          </p>
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-3xl shadow-sm overflow-hidden p-6 md:p-8">
        <div className="flex items-center gap-2 mb-8 pb-4 border-b border-slate-100">
          <ReceiptText className="w-5 h-5 text-[#8C6208]" />
          <h2 className="text-lg font-bold text-slate-800">Informasi Varian & Produk</h2>
        </div>
        <div className="space-y-8">
          {(po.products || []).map((prod, idx) => (
            <MarketingProductCard 
              key={idx}
              index={idx}
              product={{...prod, forceExpanded: true}} 
              botolList={botolList}
              tutupList={tutupList}
              sprayList={sprayList}
              bahanList={bahanList}
              fullsetList={fullsetList}
              canRemove={false}
              readOnly={true}
              onChange={() => {}}
              onRemove={() => {}}
            />
          ))}
          {(!po.products || po.products.length === 0) && (
            <div className="text-center py-16 text-slate-400 border border-dashed border-slate-200 rounded-2xl">
               <Package className="w-16 h-16 mx-auto mb-4 opacity-30" />
               <p className="text-lg">Tidak ada detail varian di Invoice ini.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
